import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModal } from 'shared/abstract/base-modal';
import { SafeHtmlPipe } from 'shared/pipes/safeHtml.pipe';

@Component({
    selector: 'app-simple-modal',
    templateUrl: './simple-modal.component.html',
    styleUrls: ['../modal.component.scss'],
    imports: [TranslateModule, SafeHtmlPipe, NgClass],
})
export class SimpleModalComponent extends BaseModal implements OnInit {
    public data!: {
        title: string;
        body: string | string[];
        yesButtonText: string;
        noButtonText: string;
        defaultYesButton: boolean;
        type: 'top' | 'side' | 'center';
    };

    public isArrayOfBodyElements: boolean = false;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.isArrayOfBodyElements = Array.isArray(this.data.body);
    }

    public close(result: boolean): void {
        this.closeModalInstance(result);
    }
}
